import { type CollabInfrastructure } from '@canvas/document-id';

import { CfCollabStrategy } from './cf-collab-strategy';
import { type CollabStrategy } from './collab-strategy';
import { NcsCollabStrategy } from './ncs-collab-strategy';

export function getCollabStrategy(
  collabInfrastructure: CollabInfrastructure,
): CollabStrategy {
  switch (collabInfrastructure) {
    case 'ncs':
      return new NcsCollabStrategy();
    case 'cf':
    default:
      return new CfCollabStrategy();
  }
}
